<template>
  <div class="cooking-time-component">
    <v-card class="clocks-window d-flex flex-column pa-3" elevation="5">
      <v-card-title class="cooking-time-component_title">
        Время исполнения заказа
      </v-card-title>
      <v-btn
        width="100%"
        class="button-control button-control__up"
        @click="increase"
      >
        <font-awesome-icon icon="chevron-up" color="#FB8C00" />
      </v-btn>

      <div class="clocks-input d-flex align-center my-3">
        <vue-timepicker
          v-model="time"
          :minute-interval="10"
          hide-clear-button
          input-width="100%"
          hour-label="Часы"
          minute-label="Минуты"
        />
      </div>

      <v-btn
        width="100%"
        class="button-control button-control__down"
        @click="decrease"
      >
        <font-awesome-icon icon="chevron-down" color="#FB8C00" />
      </v-btn>

      <v-row class="mt-4 mb-4" dense>
        <v-col v-for="(preset, i) in timePresets" :key="i" sm="4">
          <v-btn class="button-preset fullwidth" depressed @click="setTimePreset(preset.value)">
            {{ preset.key }}
          </v-btn>
        </v-col>
      </v-row>

      <div class="submit-section d-flex mt-3">
        <v-btn
          class="mr-2"
          color="#FB8C00"
          height="60px"
          dark
          depressed
          :loading="isLoading"
          @click="updateTime"
        >
          OK
        </v-btn>
        <v-btn height="60px" depressed @click="close">
          Отмена
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import VueTimepicker from 'vue2-timepicker'
  import 'vue2-timepicker/dist/VueTimepicker.css'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'CookingTime',
    components: {
      VueTimepicker,
    },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        isLoading: false,
        time: {
          HH: '00',
          mm: '00',
        },
        seconds: 0,
        timePresets: [
          { key: '1:00', value: 3600 },
          { key: '1:10', value: 4200 },
          { key: '1:30', value: 5400 },
          { key: '1:40', value: 6000 },
          { key: '1:50', value: 6600 },
          { key: '2:00', value: 7200 },
        ],
      }
    },
    watch: {
      time (newVal) {
        this.seconds = newVal.HH * 3600 + newVal.mm * 60
      },
    },
    mounted () {
      this.seconds = this.basket.cookingAndDeliveryTime
      this.convertSeconds()
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
      }),
    },
    methods: {
      setTimePreset (value) {
        this.seconds = value
        this.convertSeconds()
      },
      updateTime () {
        this.isLoading = true
        const data = {
          cookingAndDeliveryTime: this.seconds,
        }
        const id = this.basket.id
        this.$store
          .dispatch('baskets/updateBasket', { data, id })
          .then((res) => {
            if (res.status === 200) {
              this.$store.dispatch('baskets/fetchSingleBasket', this.basket.id)
              this.close()
            } else {
              this.isLoading = false
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      increase () {
        if (this.seconds < 85800) {
          console.log(this.seconds)
          this.seconds += 600
          this.convertSeconds()
        }
      },
      decrease () {
        if (this.seconds !== 0) {
          this.seconds -= 600
          this.convertSeconds()
        }
      },
      convertSeconds () {
        let hours = `${Math.floor((this.seconds / 60) / 60)}`
        let minutes = ((this.seconds / 60) % 60).toFixed(0)
        if (hours.length === 1) {
          hours = '0' + hours
        }
        if (minutes.length === 1) {
          minutes = '0' + minutes
        }
        this.time.HH = hours
        this.time.mm = minutes
      },
      close () {
        this.$emit('close')
      },
    },
  }
</script>

<style lang="less" scoped>
  .cooking-time-component {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: calc(100% + 10px);

    .clocks-window {
      border-radius: 10px;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.24), 0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0) !important;
    }

    button {
      //border-radius: 10px;
    }

    &_title {
      font-size: 22px;
      font-weight: 500;
      text-align: center;
      padding: 0;
      margin-bottom: 20px;
    }

    .submit-section {
      button {
        flex: 1;
        font-size: 18px;
        border-radius: 10px;
      }
    }

    ::v-deep {
      .vue__time-picker-dropdown, .vue__time-picker .dropdown {
        border-radius: 0 0 10px 10px;
        top: calc(100% - 1px);
        left: 0;
        right: 0;
        box-shadow: 3px 5px 5px 2px rgba(0, 0, 0, 0.1);
        border: 1px solid #d2d2d2;
        height: 12.6em;
        .select-list {
          height: 12.5em;
        }
      }

      .select-list {
        //box-shadow: 3px 5px 5px 2px rgba(0, 0, 0, 0.1);
        border-radius: 0 0 10px 10px;
        overflow: hidden;
        //margin-left: 2px;
        //margin-right: 2px;
        //width: calc( 100% - 4px ) !important;
        //border: 1px solid #e0e0e0;
      }

      .vue__time-picker-dropdown ul li,
      .vue__time-picker .dropdown ul li {
        padding: 0.6em 0;

        &.active, &.active:hover {
          background-color: @color-primary;
        }

        &.hint {
          padding: 0.3em 0;
        }

      }

      .vue__time-picker {
        input {
          outline: none;
        }
        input.display-time {
          font-size: 24px;
        }
      }
    }

    .button-preset {
      font-size: 18px;
    }

    .button-control {
      svg {
        width: 24px;
        height: 24px;
      }

      &__up {
        border-radius: 10px 10px 0 0;
      }

      &__down {
        border-radius: 0 0 10px 10px;
      }
    }

    ::v-deep {
      .vue__time-picker {
        input.display-time.invalid:not(.skip-error-style) {
          border-color: #fb8b00;
          outline-color: #fb8b00;
        }
      }
    }
  }
</style>
